import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { MegatrendsRelations } from 'src/app/models/obs/MegatrendsRelations';
import { MegatrendsRelationsService } from 'src/app/services/obs/megatrends-relations.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { ErrorHandlingService } from 'src/app/services/util/error-handling.service';

@Component({
  selector: 'app-admmega-interrelationship-form',
  templateUrl: './admmega-interrelationship-form.component.html',
  styleUrl: './admmega-interrelationship-form.component.scss'
})
export class AdmmegaInterrelationshipFormComponent implements OnInit {

  msg: Message;
  form: FormGroup;
  idTier1: string;
  idGlobalTrend: string = '11';
  edit: boolean = false;
  megaTrendRelation: MegatrendsRelations = null;
  idInter: number = 29;//

  megatrends: any[] = [];
  trends: any[] = [];
  relation: any = [
    {
      id: 1,
      value: 2,
      title: 'débil',
    },
    {
      id: 2,
      value: 3,
      title: 'moderada',
    },
    {
      id: 3,
      value: 4,
      title: 'fuerte',
    },
  ];
  listInterrelationship: any[] = [];
  selectedtrendName: string = '';
  usedTrends: any[] = [];
  selectedTrend: any | null = null;
  initialFormValues: any


  constructor(
    private t3Service: Tier3Service,
    private mtrService: MegatrendsRelationsService,
    private fb: FormBuilder,
    private errorService: ErrorHandlingService,
    private activedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idTier1 = params['id'];
    this.createForm();
    this.getAllTrends();
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idtier3: [null, Validators.required],
      idtier3related: [null, Validators.required],
      source: ['', Validators.required],
      target: ['', Validators.required],
      relation: [null, Validators.required],
      status: [true]
    });
    this.initialFormValues = this.form.value;
  }

  invalidField(field: string) {
    return this.form.get(field).invalid && this.form.get(field).touched;
  }

  loadToEditInterrelationship(obj: any) {
    this.edit = true;
    this.form.patchValue({
      id: obj.id,
      idtier3: obj.idtier3,
      source: obj.code,
      relation: obj.relation,
      status: obj.status
    });
  }


  save() {
    this.getMegatrendCode(this.form.get('idtier3').value);
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    }
  }

  create(mt: MegatrendsRelations) {
    delete mt.id;
    this.mtrService.create(mt).subscribe({
      next: res => {
        this.getAllMegatrensRelations(this.selectedTrend.id);
        this.afterSaveOrUpdate();
      },
      error: err => {
        this.msg = this.errorService.handleError(err);
      }
    })
  }

  update(id: string, mt: MegatrendsRelations) {
    this.mtrService.update(id, mt).subscribe({
      next: res => {
        this.getAllMegatrensRelations(this.selectedTrend.id);
        this.afterSaveOrUpdate();
      },
      error: err => console.error(err)
    });
  }

  getAllMegatrends() {
    this.t3Service.getAllByIdT14Admin(this.idTier1).subscribe({
      next: async ({ data }: any) => {
        this.megatrends = data;
      },
      error: err => {
        this.msg = this.errorService.handleError(err);
      }
    })
  }

  getAllTrends() {
    this.t3Service.getAllByIdT14Admin(this.idGlobalTrend).subscribe({
      next: async ({ data }: any) => {
        this.trends = data;
        this.onTrendSelected(this.trends[0])
      },
      error: err => {
        this.msg = this.errorService.handleError(err);
      }
    })
  }

  getAllMegatrensRelations(idtier3: string) {
    this.mtrService.getByTier3(idtier3).subscribe({
      next: async ({ data }: any) => {
        this.listInterrelationship = data;
      },
      error: err => {
        this.msg = this.errorService.handleError(err);
      }
    })
  }

  onTrendSelected(selectedTrend: any) {
    this.selectedTrend = selectedTrend;
    const selectedtrend = this.trends.find(m => m.id == this.selectedTrend.id);
    if (this.selectedTrend.id) {
      this.form.get('idtier3related').setValue(selectedTrend.id);
      this.form.get('target').setValue(selectedTrend.code);
      this.getAllMegatrensRelations(this.selectedTrend.id);
      this.getAllMegatrends();
    }
    if (selectedtrend) {
      this.selectedtrendName = selectedtrend.shorttitle + " " + selectedTrend.code;
    }
  }

  getMegatrendCode(idtier3: any) {
    const matchedMegatrend = this.megatrends.find(m => m.id === idtier3);
    if (matchedMegatrend) {
      this.form.get('source').setValue(matchedMegatrend.code);
    }
  }


  MegatrendSelected(selectedMTCode: string): boolean {
    return this.listInterrelationship.some(sp => sp.code === selectedMTCode);
  }

  getRelationTitle(relationValue: number): string {
    const relation = this.relation.find(r => r.value === relationValue);
    return relation ? relation.title : '';
  }

  afterSaveOrUpdate() {
    this.form.get('idtier3').setValue(null);
    this.form.get('relation').setValue(null);
    this.form.get('id').setValue(null);
    this.getAllMegatrensRelations(this.selectedTrend.id);
    this.edit = false;
  }

}
